import { render, staticRenderFns } from "./block-hero.vue?vue&type=template&id=47c932c0&scoped=true&"
import script from "./block-hero.vue?vue&type=script&lang=js&"
export * from "./block-hero.vue?vue&type=script&lang=js&"
import style0 from "./block-hero.vue?vue&type=style&index=0&id=47c932c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c932c0",
  null
  
)

export default component.exports